/**
 * Saves an already-fetched document archive (zip) blob to the user's
 * downloads via a throwaway anchor click. Shared between the provider and
 * admin "Download all" actions so the object-URL bookkeeping lives in one
 * place.
 */
export function triggerArchiveBlobDownload(download: { blob: Blob; filename: string }): void {
  const url = URL.createObjectURL(download.blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = download.filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
